import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';

import { makeStyles } from 'tss-react/mui';
import NonNationalUploadDocument from '../../../modules/examRegistration/components/nonNationalExam/NonNationalUploadDocument';
import NonNationalExamTypeUuidDisplay from './NonNationalExamTypeUuidDisplay';
import { ParentParticularsLocation } from './AEIS/ParentParticulars';
import VacancyExpiredModal from './VacancyExpiredModal';

const useStyles = makeStyles()(() => ({
  stepper: {
    position: 'relative',
    left: '-1.3%',
  },
}));

interface UploadSupportingDocumentsPageProps {
  routeSteps: { label: string | JSX.Element; disabled?: boolean }[];
  isAEIS: boolean;
  isOpsAdmin?: boolean;
}

const UploadSupportingDocuments = ({
  routeSteps,
  isAEIS,
  isOpsAdmin,
}: UploadSupportingDocumentsPageProps) => {
  const { uuid } = useParams<{ uuid: string }>();
  const { state } = useLocation<ParentParticularsLocation>();
  const { t } = useTranslation();
  const { classes } = useStyles();
  const examTitle =
    t('exam->>RegisterExam.RegisterForAnExam') +
    (state?.isSupplementary ? ` - ${t('exam->>Instructions.Supplementary')}` : '');

  return (
    <>
      <TitleHeader title={isOpsAdmin ? t('exam->>NonNationalExam.ReviewApplication') : examTitle} />
      <HeaderTemplate>
        <NonNationalExamTypeUuidDisplay nonExamType={state?.examTitle || '-'} enableApi={false} />
        <div className={classes.stepper}>
          <Stepper activeStep={2} steps={routeSteps} className={classes.stepper} />
        </div>
      </HeaderTemplate>
      <NonNationalUploadDocument isAEIS={isAEIS} isOpsAdmin={isOpsAdmin} />
      {!isOpsAdmin && <VacancyExpiredModal uuid={uuid} />}
    </>
  );
};

export default UploadSupportingDocuments;
